import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(0 -5)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M12,14.5v-.75"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M12,19v.75"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10.7,18.464a1.081,1.081,0,0,0,.927.538h.822a1.053,1.053,0,0,0,.256-2.075L11.3,16.574a1.053,1.053,0,0,1,.256-2.075h.822a1.08,1.08,0,0,1,.925.536"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20,11.242a10.345,10.345,0,0,1-7.48,9.686,1.914,1.914,0,0,1-1.04,0A10.344,10.344,0,0,1,4,11.242V7.214A2,2,0,0,1,5.243,5.363l4.864-1.99a5,5,0,0,1,3.787,0l4.864,1.99A2,2,0,0,1,20,7.214Z"
		})
	]
});
export default SvgShield;
